module.exports = __webpack_public_path__ + "static/media/right-caret-green.0e0ad4eb.svg";